/* global Datamap */

import * as d3 from "d3";
import { geoMiller } from "d3-geo-projection";

function drawMap() {
  var width = document.getElementById("basic_choropleth").offsetWidth;
  var height = width;
  const radius = 5;
  const circleColour = "#252e4b";

  const serviceCountries = [
    "DEU",
    "GBR",
    "IRL",
    "FIN",
    "NOR",
    "SWE",
    "DNK",
    "NLD",
    "BEL",
    "FRA",
    "CHE",
    "AUT",
    "LUX",
    "ESP",
    "PRT",
    "ITA",
    "GRC",
    "ALB",
    "UKR",
    "HRV",
    "SVN",
    "SVK",
    "BIH",
    "MNE",
    "CZE",
    "POL",
    "EST",
    "LVA",
    "ROU",
    "HUN",
    "SRB",
    "KSV",
    "MKD",
    "BGR",
    "TUR",
    "CYP",
    "MDA",
    "NCL",
    "SAU",
    "IRQ",
    "SYR",
    "YEM",
    "OMN",
    "ARE",
    "QAT",
    "ISR",
    "LBN",
    "JOR",
    "PSE",
    "TKM",
    "KAZ",
    "UZB",
    "AFG",
    "PAK",
    "IND",
    "LKA",
    "TJK",
    "KGZ",
    "CHN",
    "NPL",
    "BTN",
    "MMR",
    "THA",
    "LAO",
    "VNM",
    "BGD",
    "MYS",
    "IDN",
    "PNG",
    "PHL",
    "TWN",
    "NZL",
    "AUS",
    "SLB",
    "VUT",
    "FJI",
    "KOR",
    "JPN",
    "MNG",
    "TLS",
    "BLR",
    "LTU",
    "USA",
    "ZAF",
    "ARG",
    "BHS",
    "BLZ",
    "BOL",
    "BRA",
    "BRN",
    "CAN",
    "CHL",
    "CHN",
    "COL",
    "CRI",
    "CUB",
    "DOM",
    "ECU",
    "FLK",
    "GUF",
    "GTM",
    "GUY",
    "HND",
    "HTI",
    "JAM",
    "MEX",
    "NIC",
    "PAN",
    "PER",
    "PRI",
    "PRY",
    "SLV",
    "SUR",
    "URY",
    "VEN",
  ];
  const serviceCountriesConfig = {};
  for (let i in serviceCountries) {
    serviceCountriesConfig[serviceCountries[i]] = {
      fillKey: "serviceRegion",
      strokeColor: "serviceRegion",
    };
  }

  var basic_choropleth = new Datamap({
    element: document.getElementById("basic_choropleth"),
    setProjection: function (element) {
      var projection = geoMiller()
        .translate([width / 2, height / 2])
        .scale(width / 2 / Math.PI)
        .rotate([-11, 0]);
      var path = d3.geoPath().projection(projection);
      return {
        path: path,
        projection: projection,
      };
    },
    responsive: true,
    fills: {
      defaultFill: "#e5e5e5",
      serviceRegion: "rgb(229 93 102)",
      circle: circleColour,
    },
    geographyConfig: {
      highlightOnHover: false,
      popupOnHover: false,
      borderWidth: 0.5,
      borderColor: "#e5e5e5",
      highlightFillColor: "rgb(229 93 102)",
      highlightBorderColor: "rgb(229 93 102)",
      highlightBorderWidth: 0,
      highlightBorderOpacity: 0,
      popupTemplate: function (geo, data) {
        return [
          '<div class="hoverinfo"><strong>',
          geo.properties.name,
          "</strong></div>",
        ].join("");
      },
    },
    data: serviceCountriesConfig,
  });

  basic_choropleth.bubbles(
    [
      {
        radius: radius,
        fillKey: "circle",
        yield: "London",
        latitude: 52,
        longitude: 0,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Abu Dhabi",
        latitude: 24.4,
        longitude: 50.3,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Dubai",
        latitude: 26.2,
        longitude: 54.2,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Brisbane",
        latitude: -28,
        longitude: 153,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Melbourne",
        latitude: -38,
        longitude: 145,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Perth",
        latitude: -31,
        longitude: 115.5,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Sydney",
        latitude: -33,
        longitude: 152,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Hong Kong",
        latitude: 22.5,
        longitude: 115,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Singapore",
        latitude: 2,
        longitude: 104,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "New York",
        latitude: 40.7,
        longitude: -74,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Washington, D.C.",
        latitude: 39,
        longitude: -77,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
      {
        radius: radius,
        fillKey: "circle",
        yield: "Nashville",
        latitude: 36,
        longitude: -87,
        borderColor: "#252e4b",
        borderWidth: 0,
        borderOpacity: 0,
        highlightFillKey: "circle",
        highlightBorderColor: "#252e4b",
        highlightBorderWidth: 0,
        highlightBorderOpacity: 0,
      },
    ],
    {
      popupTemplate: function (geo, data) {
        return [
          '<div class="hoverinfo"><strong>',
          data.yield,
          "</strong></div>",
        ].join("");
      },
    },
  );

  window.addEventListener("resize", function () {
    basic_choropleth.resize();
  });

  const div_tag = document.querySelector("#basic_choropleth");
  const svg_tag = document.querySelector("#basic_choropleth .datamap");
  const map_tag = document.querySelector(
    "#basic_choropleth .datamap .datamaps-subunits",
  );
  const bub_tag = document.querySelector("#basic_choropleth .datamap .bubbles");

  const bbox = map_tag.getBBox();

  div_tag.setAttribute(
    "style",
    "text-align: center; align-items: center; position: relative; margin-left: auto; margin-right: auto;",
  );

  svg_tag.setAttribute(
    "style",
    "width: 100%; margin-left: auto; margin-right: auto; align-items: center;",
  );
  svg_tag.setAttribute("viewBox", "0 0 " + bbox.width + " " + bbox.height);
  svg_tag.removeAttribute("width");
  svg_tag.removeAttribute("height");
  svg_tag.removeAttribute("data-width");

  map_tag.setAttribute(
    "style",
    "transform: translate(-" + bbox.x + "px, -" + bbox.y + "px);",
  );
  bub_tag.setAttribute(
    "style",
    "transform: translate(-" + bbox.x + "px, -" + bbox.y + "px);",
  );

  basic_choropleth.legend({
    // defaultFillName: "No data",
    labels: {
      serviceRegion: "Our coverage",
      circle: "Our offices",
    },
  });

  let dl = document.querySelector(".datamaps-legend");
  dl.style.fontFamily = "unset";
  dl.style.width = "100%";
  dl.style.position = "relative";

  let dd = document.querySelectorAll(".datamaps-legend dd");
  for (let i = 0; i < dd.length; i++) {
    dd[i].style.marginLeft = "0.5em";
    dd[i].style.marginRight = "2em";
    if (dd[i].style.backgroundColor == circleColour) {
      dd[i].style.borderRadius = "100%";
    }
  }
}

drawMap();
